export const LTD_COMPANY_CONTRACT_FIELD_IDS = Object.freeze({
  contractStartDate: "",
  arName: "",
  companyRegistrationNumber: "",
  registeredAddress: "",
  appointmentStatuses: "",
  companyRepresentativeName: "",
  companyRepresentativeTitle: "",
  lawOfContractNames: "",
  lawOfContractName: "",
  lawOfContractDate: "",
});

export const LTD_COMPANY_CONTRACT_FIELD_FALLBACKS = Object.freeze({
  contractStartDate: "…………….",
  arName: "AR Name",
  companyRegistrationNumber: "………",
  registeredAddress: "………………………………",
  appointmentStatuses: "Financial Planning Consultant",
  companyRepresentativeName: "Rosemount Financial Solutions (IFA) Ltd",
  companyRepresentativeTitle: "The 'Company'",
  lawOfContractNames: ["Name of Person"],
  lawOfContractName: "Name of Person",
  lawOfContractDate: "…………….",
});
